export function accordion(element: HTMLElement) {
  const items = [...Array.from(element.querySelectorAll('.js-item'))] as HTMLElement[]

  function toggleAccordion(event: Event) {
    const currentTarget = event.currentTarget as HTMLElement
    const icon = currentTarget.querySelector('.js-icon') as HTMLElement
    const desc = currentTarget.querySelector('.js-desc') as HTMLElement

    //get a perfect slide down
    if (desc.offsetHeight > 0) {
      // console.log('scrollUp')
      desc.style.height = `0px`
      // toggle between down arrow and straight bullet point
      icon.classList.remove('js-active')
    } else {
      // console.log('scrollDown')
      desc.style.height = `${desc.scrollHeight}px`
      // toggle between down arrow and straight bullet point
      icon.classList.add('js-active')
    }
  }

  items.map(item => {
    item.addEventListener('click', toggleAccordion)
  })
}
